import { useSelector } from "react-redux";
import { ProductNote } from "../../../Shared/Notes/Notes";
import { find, getDisplayValue } from "../../../utilities";

export const Footer = ({ item, product_edit }) => {
  const productNotes = useSelector((state) => state.productNotes);

  return (
    <div className="d-flex justify-content-between ms-1 me-1 mb-1">
      <div className="d-flex align-items-center" style={{ color: "#000000" }}>
        <img
          src={
            require(`@src/assets/images/vyrill/products/play_icon.png`).default
          }
          style={{ marginRight: "6px", width: "16px", height: "12px" }}
        />{" "}
        <span style={{ fontSize: "14px", marginTop: "1px" }}>
          {getDisplayValue(item.video_count)}
        </span>
      </div>
      <div style={{ width: "90px" }} onClick={(e) => e.stopPropagation()}>
        <ProductNote
          note={find(productNotes, item?._id, "product_id")}
          id={item._id}
          manufacturer_id={item.manufacturer_id}
          product_edit={product_edit}
          isProduct
        />
      </div>
    </div>
  );
};
